// extracted by mini-css-extract-plugin
export var blobs = "BlurredBlobs-module--blobs--fdc5e";
export var fadeIn = "BlurredBlobs-module--fadeIn--58ea3";